module.exports = __webpack_public_path__ + "img/men_with_bunny_ears.eb52d375.gif";